// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/ctas-x-cobrar/list',
    name: 'ctas-x-cobrar-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/administration/ctasXC/CtasXC.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'ctas_x_cobrar',
    },
  },
]

export default formTable
